import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RetailerHomeService } from './retailer-home.service';
import { CountryService } from '../countries/country.service';
import { ControlItem } from 'src/app/models/frontend';
import { DiscountTemplatesService } from '../discount-templates/discount-templates.service';
import Swal from 'sweetalert2';
import { LocationsService } from '../locations/locations.service';
import { ProductService } from '../products/product.service';
import { UsersService } from '../users/users.service';
import { last, Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../login/login.service';
import { ReceiverType } from 'src/app/models/enums/receiverType';
import { RetailerPlanType } from 'src/app/models/enums/retailerPlanType';
import { RetailersService } from '../retailers/retailers.service';
import { SharedService } from 'src/app/shared/services/shared.service';


@Component({
  selector: 'app-retailer-home',
  templateUrl: './retailer-home.component.html',
  styleUrls: ['./retailer-home.component.scss']
})
export class RetailerHomeComponent {

  productForm: FormGroup
  recieversOptions: any=[ { value: '0', label: 'Create New Receiver' }]
  countryOptions: any

  // intlCountryOptions: any
  // intlProviderOptions: any
  // intlProductOptions: any

  cityOptions: any
  productOptions: any

  retailerForm: FormGroup
  internationalSmallLoader=false;
  selectedCountryCode: string = "+1"; // Default country code
  phoneNumber: string = "";

  TopUpsByCustomerId: any

  //Country Items
  country: any
  intlcountryList: ControlItem[] = []

  CountryIso: any
  CountryName: any

  //ProviderItems
  ProviderCode: any
  ProviderName: any
  logoUrl: any

  providers: any
  intlprovidersOption: ControlItem[] = []

  //Product Items
  productRequest = {
    countryIso: "",
    providerCode: "",
    receiveCountryName: "",
    providerName: "",
    accountNumber: "",
    logoUrl: "",
    logRequest: true
  }
  Products: any
  intlproductsOption: ControlItem[] = []

  intlSelectedProduct: any
  intlSelectedProvider: any
  intlProductRefenceNumber: any
  intlProductUatNumber: any

  OrderItem: any = []
  ReProcessOrderItem: any = []

  CustomerPhoneNo: any;
  Customer_Sender_Id: any;

  //Domestic
  dmstcProductOptions: any
  dmstcProviderOptions: any
  dmstcProductRefenceNumber: any

  internationalEstimatePrice: any
  domesticEstimatePrice: any

  CustomerDetails: any
  customerFields = false

  recieverDetails: any
  recieverfirstName: any
  recieverlastName: any
  recieverEmail: any
  recieverMobile: any

  activeCountries: any
  activeLocations: any
  activeProducts: any
  activeSelectedCountry = 0
  activeSelectedLocation: any
  activeSelectedProduct: any

  boolCustomerFirstName = false
  boolCustomerLastName = false
  boolCustomerMobile = false
  boolRecieverFirstName = false
  boolRecieverLastName = false
  boolRecieverMobile = false

  PridCustomerFirstName: any
  PridCustomerLastName: any
  PridCustomerMobileNumber1: any = ""
  PridCustomerEmail: any
  boolPridCustomerFirstName = true
  boolPridCustomerLastName = true

  ProductMinPrice: any
  ProductMaxPrice: any
  boolAmountRange = false;

  CartTotalAmount: number = 0
  PridRecieverId: any

  selectedItem = null;
  selectedItemProduct = null;

  selectedItemInternational = null;
  selectedItemProductInternational = null;

  boolShowAmount = false
  boolShowProvider = false
  domesticPhoneError = ""

  boolShowAmountInternational = false
  boolShowProviderInternational = false

  Loader = false
  numberLoader = 0

  Role: any = 0
  pridActiveCountries: ControlItem[] = []
  CountryValue = "Select Country"

  selectedCountry: string;
  phNumber: string;
  countries = [
  ];
  flagCountries = []
  SubmitOrderButton = false
  ProductRecieverId: number

  countryControl = new FormControl();
  filteredCountries: Observable<any>;
  countriesSearch: any[] = []; // Your array of countries

  TopupList: any
  imageURL = environment.imageUrl

  intlAmountValue: number = 0
  intlunRoundedSendValue:number=0
  dmstcAmountValue: number = 0
  intrAmountValue: number = 0
  boolIntlAmountValue = false
  boolDmstcAmountValue = false
  boolIntrAmountValue = false
  countryFlagImg = ""
  internationalCountryCode = ""

  PridProductRecieverId: number = 0
  DomesticMobileNumber: string
  boolProductSection = false

  MiniLoader = false
  productDetailPage = false
  orderNumber: any

  isInternationalReceiver = false
  isDomesticReceiver = false

  btnBoolReceiver = true
  btnBoolCustomer = true

  CartProcessedAmount = 0
  CartFailedAmount = 0

  isCollapsed = false;

  @ViewChild('firstName') firstName: ElementRef;
  @ViewChild('lastName') lastName: ElementRef;
  @ViewChild('internationalAmountValue') internationalAmountValue: ElementRef;
  @ViewChild('btnAddToCartPridProduct') btnAddToCartPridProduct!: ElementRef;
  @ViewChild('hdnPridProductDetails') hdnPridProductDetails!: ElementRef;
  @ViewChild('deliveryMsg') txtDeliveryMsg!: ElementRef;

  constructor(private fb: FormBuilder, public retailerService: RetailerHomeService,
    public countryService: CountryService, public customService: DiscountTemplatesService,
    public locationService: LocationsService, public productService: ProductService,
    public userService: UsersService, private cookieService: CookieService,
    public router: Router, private toastr: ToastrService,public loginService:LoginService,
    private retailerSideBarService:SharedService,
    private renderer:Renderer2
  ) {
    this.Role = localStorage.getItem("RoleType")
    this.GetCountries()
    this.loadActiveCountries()
  }
  ngOnInit(): void {
    this.Loader = true
    this.getOrderButtonCookie()
    this.getObjectFromCookie()
    this.getCustomerObjectFromCookie()
    this.getCountryObjectFromCookie()
    this.getCustomerLocationFromCookie()
    // this.getReceiverObjectFromCookie()
  }
  async CreateRetailer(phone) {
    this.addClassToBody();
    this.isCollapsed = true;
    this.btnBoolCustomer = true
    this.btnBoolReceiver = true
    var numb = phone.replace(/[^\d]/g, "")
    phone = numb
    console.log(numb)
    this.DomesticMobileNumber = numb
    this.Loader = true;
    this.ResetAll()
    this.retailerForm = this.fb.group({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      mobileNumber: phone,
      roleType: 5,
      IsActive: true

    })
    this.CustomerPhoneNo = phone
    await this.retailerService.RegisterWhileTopUp(this.retailerForm.value).
      subscribe({
        next: async (res: any) => {
          this.CustomerDetails = res
          this.Customer_Sender_Id = res.id
          this.CustomerPhoneNo = res.mobileNumber
          console.log(this.Customer_Sender_Id)
          this.PridCustomerFirstName = res.firstName
          this.PridCustomerLastName = res.lastName
          this.PridCustomerEmail = res.email
          this.PridCustomerMobileNumber1 = res.mobileNumber
          console.log(res, this.PridCustomerFirstName)
          if (this.PridCustomerFirstName != undefined || this.PridCustomerFirstName != null || this.PridCustomerFirstName != "") {
            this.boolPridCustomerFirstName = false
          }
          if (!this.PridCustomerLastName) {
            this.boolPridCustomerLastName = false
          }

          if (!res.firstName) {
            this.boolCustomerFirstName = true
          }
          if (!res.lastName) {
            this.PridCustomerLastName = ""
            this.boolCustomerLastName = true
          }
          if (!res.mobileNumber) {
          }
          //GetTopUpByCustomerId
          await this.retailerService.GetTopUpTransactionsByCustomerId(res.id).
            subscribe({
              next: (topup: any) => {
                this.TopUpsByCustomerId = res.items
                console.log(this.TopUpsByCustomerId)
              },
              error: e => {
                if (e.error.message) {
                  this.toastr.error('Oops!', e.error.message);
                }
                else {
                  this.toastr.error('Oops!', "Something went wrong");
                }
              }
            })
          this.saveCustomerObjectToCookie(this.CustomerDetails)
          this.loadRecievers()
          this.loadActiveCountries()
          this.GetTopUpTransactionsByCustomerId()
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
    // this.PridCustomerMobileNumber1 = "1234567890"
    // this.PridCustomerFirstName = "Abdul"
    // this.PridCustomerLastName = "Muiz"
    // this.CustomerPhoneNo="1234567890"
    // this.Customer_Sender_Id=7

  }
  async CreateRetailerFromCookie(phone) {
    var numb = phone.replace(/[^\d]/g, "")
    phone = numb
    this.Loader = true;
    this.retailerForm = this.fb.group({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      mobileNumber: phone,
      roleType: 5,
      IsActive: true

    })
    this.CustomerPhoneNo = phone
    await this.retailerService.RegisterWhileTopUp(this.retailerForm.value).subscribe({
      next: async (res: any) => {
        this.CustomerDetails = res
        this.Customer_Sender_Id = res.id
        this.CustomerPhoneNo = res.mobileNumber
        console.log(this.Customer_Sender_Id)
        this.PridCustomerFirstName = res.firstName
        this.PridCustomerLastName = res.lastName
        this.PridCustomerEmail = res.email
        this.PridCustomerMobileNumber1 = res.mobileNumber
        console.log(res, this.PridCustomerFirstName)
        if (this.PridCustomerFirstName != undefined || this.PridCustomerFirstName != null || this.PridCustomerFirstName != "") {
          this.boolPridCustomerFirstName = false
        }
        if (!this.PridCustomerLastName) {
          this.boolPridCustomerLastName = false
        }

        if (!res.firstName) {
          this.boolCustomerFirstName = true
        }
        if (!res.lastName) {
          this.PridCustomerLastName = ""
          this.boolCustomerLastName = true
        }
        if (!res.mobileNumber) {
        }
        //GetTopUpByCustomerId
        await this.retailerService.GetTopUpTransactionsByCustomerId(res.id).subscribe
          ({
            next: (topup: any) => {
              this.TopUpsByCustomerId = res.items
              console.log(this.TopUpsByCustomerId)
            }
            ,
            error: e => {
              if (e.error.message) {
                this.toastr.error('Oops!', e.error.message);
              }
              else {
                this.toastr.error('Oops!', "Something went wrong");
              }
            }
          })

        this.saveCustomerObjectToCookie(this.CustomerDetails)
        await this.loadRecievers()
        this.GetTopUpTransactionsByCustomerId()
        this.getReceiverObjectFromCookie()
        this.Loader = false
      }
      ,
      error: e => {
        if (e.error.message) {
          this.toastr.error('Oops!', e.error.message);
        }
        else {
          this.toastr.error('Oops!', "Something went wrong");
        }
      }
    })

  }
  async GetCountries() {
    this.boolAmountRange = false
    this.intlcountryList = []
    this.customService.GetCountries().subscribe
      ({
        next: (res: any) => {
          this.country = res.items
          this.countries = []
          for (let i = 0; i < this.country.length; i++) {
            if (this.country[i].internationalDialingInformation.length > 0) {
              this.intlcountryList.push({ value: this.country[i].countryIso, label: this.country[i].countryName, label2: this.country[i].internationalDialingInformation[0].prefix })
              this.countries.push({
                name: this.country[i].countryName,
                code: this.country[i].internationalDialingInformation[0].prefix,
                flag: this.country[i].flagURL,
                iso: this.country[i].countryIso
              })
              for (let j = 0; j < this.country[i].internationalDialingInformation.length; j++) {
                this.flagCountries.push({
                  name: this.country[i].countryName,
                  code: this.country[i].internationalDialingInformation[j].prefix,
                  flag: this.country[i].flagURL,
                  iso: this.country[i].countryIso
                })
              }
            }

          }
          console.log(this.flagCountries)
        },
        error: e => {
          if (e.error.message) {
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })

  }
  GetSingleCountry(countryCode) {
    console.log(this.countries, this.intlcountryList)
    var selectedCountry = this.flagCountries.find(m => m.code == countryCode)
    console.log(selectedCountry)
    this.CountryValue = selectedCountry.name
    this.GetProviders(selectedCountry.iso)
  }
  async GetProviders(id) {
    this.boolShowProviderInternational=true
    console.log(id)
    this.Loader = true
    this.CountryIso = id
    const selectedCountry = this.flagCountries.find(country => country.iso === id);
    this.CountryName = selectedCountry.name
    this.intlprovidersOption = []
    this.customService.GetProviders(id).subscribe
      ({
        next: (res: any) => {
          this.providers = res
          console.log(this.providers)
          this.Loader = false
          this.intlprovidersOption = []
          this.Loader = false
          for (let i = 0; i < this.providers.length; i++) {
            this.intlprovidersOption.push({ value: this.providers[i].providerCode, label: this.providers[i].name, label2: this.providers[i].logoUrl })
          }
        },
        error: e => {
          if (e.error.message) {
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
    this.Loader = false
  }
  async GetProviderByPhoneNumber(phone, iso) {
    this.Loader = true
    this.numberLoader = 1
    this.intlprovidersOption = []
    this.customService.GetProvidersByPhoneNumber(phone, iso).subscribe
      ({
        next: (res: any) => {
          this.providers = res
          this.intlprovidersOption = []
          for (let i = 0; i < this.providers.length; i++) {
            console.log(res[i].providerCode)
            var value = res[i].providerCode
            this.intlprovidersOption.push({ value: value, label: this.providers[i].name, label2: this.providers[i].logoUrl })
          }
          console.log(this.intlprovidersOption)
          this.GetProductsByProviders(this.intlprovidersOption[0].value, phone)
          this.Loader = false
          this.numberLoader = 0
        }
      })
    this.Loader = false
    this.numberLoader = 0
  }
  async GetDomesticProviders() {
    this.Loader = true
    this.boolAmountRange = false
    this.CountryIso = "US"
    console.log(this.intlcountryList)
    var selectedCountry ={label:'',label2:'',value:''}
    selectedCountry.label = "United States"
    selectedCountry.label2="1201"
    selectedCountry.value = "US"
    console.log(selectedCountry)
    this.CountryName = "United States"
    // this.CountryName = selectedCountry.label
    this.intlprovidersOption = []
    this.customService.GetProviders("US").subscribe({
      next: (res: any) => {
        console.log(res)
        this.providers = res
        this.dmstcProviderOptions = []
        this.Loader = false
        for (let i = 0; i < this.providers.length; i++) {
          this.dmstcProviderOptions.push({ value: this.providers[i].providerCode, label: this.providers[i].name, label2: this.providers[i].logoUrl })
        }
        console.log(this.dmstcProviderOptions)
      },
      error: e => {
        if (e.error.message) {
          this.toastr.error('Oops!', e.error.message);
        }
        else {
          this.toastr.error('Oops!', "Something went wrong");
        }
      }
    })

  }
  GetProducts(id, accountNumber) {
    var numb = accountNumber.replace(/[^\d]/g, "")
    accountNumber = numb
    this.Loader = true
    this.boolIntlAmountValue = false
    this.ProviderCode = id.value
    const selectedProviders = this.intlprovidersOption.find(provider => provider.value === id.value);
    this.intlSelectedProvider = selectedProviders
    console.log(this.intlSelectedProvider)
    this.ProviderName = selectedProviders.label
    this.logoUrl = selectedProviders.label2
    // this.LogoURL = selectedProviders.label2

    this.productRequest = {
      countryIso: this.regionCode,
      providerCode: this.ProviderCode,
      receiveCountryName: "",
      providerName: this.ProviderName,
      accountNumber: accountNumber, //923440118470
      logoUrl: this.logoUrl,
      logRequest: true
    }
    console.log(this.productRequest)
    this.customService.GetProducts(this.productRequest).subscribe
      ({
        next: (res: any) => {
          console.log(res.result.prideReferenceNumber, res.result)
          this.intlProductRefenceNumber = res.result.pridReferenceNumber
          this.intlProductUatNumber = res.result.uatNumber
          this.Products = res.result.items
          this.Loader = false
          this.intlproductsOption = []
          for (let i = 0; i <= this.Products.length; i++) {
            if(this.Products[i].maximum.sendValue==this.Products[i].minimum.sendValue)
              {
                this.intlproductsOption.push({ value: this.Products[i].skuCode, label:"$"+this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode })
              }
              else{
                this.intlproductsOption.push({ value: this.Products[i].skuCode, label:"$"+this.Products[i].minimum.sendValue+" - "+ "$"+this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode })
              }
            // this.intlproductsOption.push({ value: this.Products[i].skuCode, label: this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode })
          }
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })

  }
  GetProductsbyCards(id, accountNumber) {
    var numb = accountNumber.replace(/[^\d]/g, "")
    accountNumber = numb
    this.Loader = true
    this.boolIntlAmountValue = false
    this.ProviderCode = id
    const selectedProviders = this.intlprovidersOption.find(provider => provider.value === id);
    this.intlSelectedProvider = selectedProviders
    console.log(this.intlSelectedProvider)
    this.ProviderName = selectedProviders.label
    this.logoUrl = selectedProviders.label2
    // this.LogoURL = selectedProviders.label2

    this.productRequest = {
      countryIso: this.regionCode,
      providerCode: this.ProviderCode,
      receiveCountryName: "",
      providerName: this.ProviderName,
      accountNumber: accountNumber, //923440118470
      logoUrl: this.logoUrl,
      logRequest: true
    }
    console.log(this.productRequest)
    this.customService.GetProducts(this.productRequest).subscribe
      ({
        next: (res: any) => {
          console.log(res.result.prideReferenceNumber, res.result)
          this.intlProductRefenceNumber = res.result.pridReferenceNumber
          this.intlProductUatNumber = res.result.uatNumber
          this.Products = res.result.items
          this.Loader = false
          this.intlproductsOption = []
          for (let i = 0; i < this.Products.length; i++) {
            if(this.Products[i].maximum.sendValue==this.Products[i].minimum.sendValue)
              {
                this.intlproductsOption.push({ value: this.Products[i].skuCode, label: "$"+this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode,unRoundedSendValue:this.Products[i].maximum.unRoundedSendValue,defaultDisplayText:this.Products[i].defaultDisplayText })
              }
              else{
                this.intlproductsOption.push({ value: this.Products[i].skuCode, label:"$"+this.Products[i].minimum.sendValue+" - "+ "$"+this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode,unRoundedSendValue:this.Products[i].maximum.unRoundedSendValue,defaultDisplayText:this.Products[i].defaultDisplayText   })
              }
            // this.intlproductsOption.push({ value: this.Products[i].skuCode, label: this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode })
          }
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })

  }
  GetProductsByProviders(id, accountNumber) {
    console.log(id, accountNumber)
    this.Loader = true
    this.boolIntlAmountValue = false
    this.ProviderCode = id
    const selectedProviders = this.intlprovidersOption.find(provider => provider.value === id);
    this.intlSelectedProvider = selectedProviders
    this.ProviderName = selectedProviders.label
    this.logoUrl = selectedProviders.label2

    this.productRequest = {
      countryIso: this.regionCode,
      providerCode: this.ProviderCode,
      receiveCountryName: "",
      providerName: this.ProviderName,
      accountNumber: accountNumber, //923440118470
      logoUrl: this.logoUrl,
      logRequest: true
    }
    this.customService.GetProducts(this.productRequest).subscribe
      ({
        next: (res: any) => {

          this.intlProductRefenceNumber = res.result.pridReferenceNumber
          this.intlProductUatNumber = res.result.uatNumber
          this.Products = res.result.items
          // this.Loader = false
          this.intlproductsOption = []
          for (let i = 0; i < this.Products.length; i++) {
            console.log(this.Products)
            if(this.Products[i].maximum.sendValue==this.Products[i].minimum.sendValue)
            {
              this.intlproductsOption.push({ value: this.Products[i].skuCode, label: "$"+this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode })
            }
            else{
              this.intlproductsOption.push({ value: this.Products[i].skuCode, label:"$"+this.Products[i].minimum.sendValue+" - "+ "$"+this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode })
            }
          }
          this.Loader = false
          this.changeIntlProductByDefault(this.intlproductsOption[0].value)
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })

  }
  reloadProduct(topup: any,txtPhoneNumber:any) {
    

  }
  GetDomesticProducts(id, accountNumber) {
    var numb = accountNumber.replace(/[^\d]/g, "")
    accountNumber = numb
    this.Loader = true
    this.ProviderCode = id
    const selectedProviders = this.dmstcProviderOptions.find(provider => provider.value === id);
    this.intlSelectedProvider = selectedProviders
    this.ProviderName = selectedProviders.label
    this.logoUrl = selectedProviders.label2
    console.log(this.logoUrl)
    this.productRequest = {
      countryIso: this.CountryIso,
      providerCode: this.ProviderCode,
      receiveCountryName: "",
      providerName: this.ProviderName,
      accountNumber: accountNumber, //923440118470
      //accountNumber:"13349205869",
      logoUrl: this.logoUrl,
      logRequest: true
    }
    this.boolShowAmount = true
    console.log(this.productRequest)
    this.customService.GetProducts(this.productRequest).subscribe
      ({
        next: (res: any) => {
          this.intlProductRefenceNumber = res.result.pridReferenceNumber
          this.Products = res.result.items
          this.dmstcProductOptions = []
          this.Loader = false
          console.log('domestic products',this.Products);
          for (let i = 0; i < this.Products.length; i++) {
            if(this.Products[i].maximum.sendValue==this.Products[i].minimum.sendValue)
              {
                this.dmstcProductOptions.push({ value: this.Products[i].skuCode, label: "$"+this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode,defaultDisplayText: this.Products[i].defaultDisplayText})
              }
              else{
                this.dmstcProductOptions.push({ value: this.Products[i].skuCode, label:"$"+this.Products[i].minimum.sendValue+" - "+ "$"+this.Products[i].maximum.sendValue, label2: this.Products[i].skuCode,defaultDisplayText: this.Products[i].defaultDisplayText })
              }
            // this.dmstcProductOptions.push({ value: this.Products[i].skuCode, label: this.Products[i].defaultDisplayText, label2: this.Products[i].skuCode })
          }
          console.log(this.dmstcProductOptions)
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })

  }
  changeIntlProduct(id) {
    this.intlAmountValue=null
    this.boolIntlAmountValue = false
    this.Loader = true
    this.intlSelectedProduct = this.Products.find(product => product.skuCode == id.value)
    console.log('product selected ',this.intlSelectedProduct)
    this.boolAmountRange = true
    if (this.intlSelectedProduct.maximum.sendValue == this.intlSelectedProduct.minimum.sendValue) {
      this.intlAmountValue = this.intlSelectedProduct.maximum.sendValue
      this.intlunRoundedSendValue=this.intlSelectedProduct.maximum.unRoundedSendValue
      this.boolIntlAmountValue = true

      this.dmstcAmountValue = this.intlSelectedProduct.maximum.sendValue
      this.boolDmstcAmountValue = true
    }
    this.Loader = false
  }
  changeIntlProductByDefault(id) {
    this.boolIntlAmountValue = false
    this.Loader = true
    console.log(id)
    this.intlSelectedProduct = this.Products.find(product => product.skuCode == id)
    console.log(this.intlSelectedProduct)
    this.boolAmountRange = true
    if (this.intlSelectedProduct.maximum.sendValue == this.intlSelectedProduct.minimum.sendValue) {
      this.intlAmountValue = this.intlSelectedProduct.maximum.sendValue
      this.boolIntlAmountValue = true

      this.dmstcAmountValue = this.intlSelectedProduct.maximum.sendValue
      this.boolDmstcAmountValue = true
    }
    this.Loader = false
  }
  async AddToCartInternational(amount, countryCode, recieverPhone, firstName, lastName) {
    var numb = recieverPhone.replace(/[^\d]/g, "")
    recieverPhone = numb
    console.log(this.intlSelectedProduct,recieverPhone)
    if (this.intlSelectedProduct == null || this.intlSelectedProduct == "" || this.intlSelectedProduct == undefined) {
      Swal.fire("Validation Error", "Please Select Product", 'error')
      return
    }
    if (firstName == null || firstName == "" || firstName == undefined) {
      firstName = ""
    }
    if (lastName == null || lastName == "" || lastName == undefined) {
      lastName = ""
    }

    if (amount == null || amount == "" || amount == undefined) {
      Swal.fire("Validation Error", "Please enter Amount", 'error')
      return
    }
    if (recieverPhone == null || recieverPhone == "" || recieverPhone == undefined) {
      Swal.fire("Validation Error", "Please enter Receiver Phone Number", 'error')
      return
    }

    this.Loader = true
    const sender_Id = parseInt(this.Customer_Sender_Id, 10)

    const totalAmount = parseFloat(amount)

    var recieverReq = {
      firstName: firstName,
      lastName: lastName,
      mobileNumber1: recieverPhone.toString().trim(),
      mobileNumber2: "",
      address: "",
      email: "",
      customerPhoneNumber: this.CustomerPhoneNo,
      sender_Customer_UserId: this.Customer_Sender_Id,
      recieverType:ReceiverType.TopUp
    }
    var SKU = this.intlSelectedProduct.skuCode
    var commissionRate = this.intlSelectedProduct.commissionRate.toString()
    var processingMode = this.intlSelectedProduct.processingMode
    var redemptionMechanism = this.intlSelectedProduct.redemptionMechanism
    var displayText = this.intlSelectedProduct.defaultDisplayText
    var pridReferenceNumber = this.intlProductRefenceNumber
    var imageURL = this.intlSelectedProvider.label2
    var providerCode = this.intlSelectedProvider.value
    var unRoundedValue=0;
    if(this.intlSelectedProduct.maximum.sendValue==this.intlSelectedProduct.minimum.sendValue)
      unRoundedValue=parseFloat(this.intlSelectedProduct.maximum.unRoundedSendValue);
    else 
    unRoundedValue=totalAmount;
    var RecieverId
    await this.userService.CreatePridReciever(recieverReq).subscribe
      ({
        next: (res: any) => {
          console.log(res, SKU, commissionRate)
          RecieverId = res.id
          var estimatePayload = {
            sendValue: totalAmount,
            skuCode: SKU,
            batchItemRef: pridReferenceNumber,
            uatNumber: pridReferenceNumber,
            commissionRate: commissionRate,
            processingMode: processingMode,
            redemptionMechanism: redemptionMechanism,
            logRequest: true,
            pridReferenceNumber: pridReferenceNumber,
            defaultDisplayText: displayText,
            recieverId: RecieverId,
            sender_Customer_UserId: sender_Id,
            unRoundedSendValue:unRoundedValue
          }
          console.log(estimatePayload)
          this.customService.EstimatePrice(estimatePayload).subscribe
            ({
              next: (estimate: any) => {
                this.CartTotalAmount = this.CartTotalAmount + totalAmount
                
                this.internationalEstimatePrice = estimate
                this.OrderItem.push({
                  pridReferenceNumber: estimate.pridReferenceNumber,
                  sku: estimate.sku,
                  productType: 2,
                  retailPrice: estimate.retailPrice,
                  quantity: estimate.quantity,
                  totalRetailPrice: estimate.totalRetailPrice,
                  orderId: estimate.orderId,
                  orderNumber: estimate.orderNumber,
                  discountPercentage: estimate.discountPercentage,
                  retailCost: estimate.retailCost,
                  totalRetailCost: estimate.totalRetailCost,
                  prideComissionPercentage: estimate.prideComissionPercentage,
                  pridProfit: estimate.pridProfit,
                  isProcessed: estimate.isProcessed,
                  isTestRecord: estimate.isTestRecord,
                  country: estimate.country,
                  providerName: estimate.providerName,
                  productDisplayText: estimate.productDisplayText,
                  logoUrl: estimate.logoUrl,
                  phoneNumber: estimate.phoneNumber,
                  productName: estimate.productName,
                  recieverId: estimate.recieverId,
                  unRoundedSendValue:estimate.unRoundedSendValue,
                })
                // Swal.fire("Success", "Item added to cart successfully", 'success')
                // this.toastr.success('Item added to cart successfully', 'Success')
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.Loader = false
              },
              error: e => {
                if (e.error.message) {
                  this.Loader = false
                  this.toastr.error('Oops!', e.error.message);
                }
                else {
                  this.Loader = false
                  this.toastr.error('Oops!', "Something went wrong");
                }
              }
            })
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
    // setTimeout(() => {
    //   console.log(SKU)
    //   this.OrderItem.push({
    //     pridReferenceNumber: pridReferenceNumber,
    //     sku: SKU,
    //     productType: 2,
    //     retailPrice: amount,
    //     quantity: 1,
    //     totalRetailPrice: amount * 1,
    //     orderId: 0,
    //     orderNumber: "",
    //     discountPercentage: 0,
    //     retailCost: 0,
    //     totalRetailCost: 0,
    //     prideComissionPercentage: 0,
    //     pridProfit: 0,
    //     isProcessed: false,
    //     isTestRecord: false,
    //     country: this.CountryIso,
    //     providerName: providerCode,
    //     productDisplayText: displayText,
    //     logoUrl: imageURL,
    //     phoneNumber: recieverPhone,
    //     productName: displayText,
    //     recieverId: RecieverId
    //   })
    //   console.log(this.OrderItem)

    // }, 1000);

    this.saveObjectToCookie(this.OrderItem)
    this.ResetAddToCartInternational()

  }
  async AddToCartDomestic(amount, countryCode, recieverPhone) {
    var numb = recieverPhone.replace(/[^\d]/g, "")
    recieverPhone = numb
    var SKU = this.intlSelectedProduct.skuCode
    var commissionRate = this.intlSelectedProduct.commissionRate.toString()
    var processingMode = this.intlSelectedProduct.processingMode
    var redemptionMechanism = this.intlSelectedProduct.redemptionMechanism
    var displayText = this.intlSelectedProduct.defaultDisplayText
    var pridReferenceNumber = this.intlProductRefenceNumber
    var imageURL = this.intlSelectedProvider.label2
    var providerCode = this.intlSelectedProvider.value
    

    this.Loader = true
    const sender_Id = parseInt(this.Customer_Sender_Id, 10)
    const totalAmount = parseFloat(amount)

    var unRoundedValue=0;
    if(this.intlSelectedProduct.maximum.sendValue==this.intlSelectedProduct.minimum.sendValue)
      unRoundedValue=parseFloat(this.intlSelectedProduct.maximum.unRoundedSendValue);
    else 
    unRoundedValue=totalAmount;

    // this.CartTotalAmount = this.CartTotalAmount + totalAmount
    var recieverReq = {
      firstName: "",
      lastName: "",
      mobileNumber1: recieverPhone.toString().trim(),
      mobileNumber2: "",
      address: "",
      email: "",
      customerPhoneNumber: this.CustomerPhoneNo,
      sender_Customer_UserId: this.Customer_Sender_Id,
      recieverType:ReceiverType.TopUp
    }
    var RecieverId
    this.userService.CreatePridReciever(recieverReq).subscribe
      ({
        next: (res: any) => {
          RecieverId = res.id
          var estimatePayload = {
            sendValue: totalAmount,
            skuCode: SKU,
            batchItemRef: pridReferenceNumber,
            uatNumber: pridReferenceNumber,
            commissionRate: commissionRate,
            processingMode: processingMode,
            redemptionMechanism: redemptionMechanism,
            logRequest: true,
            pridReferenceNumber: pridReferenceNumber,
            defaultDisplayText: displayText,
            recieverId: RecieverId,
            sender_Customer_UserId: sender_Id,
            unRoundedSendValue:unRoundedValue
          }
          console.log(estimatePayload)
          this.customService.EstimatePrice(estimatePayload).subscribe
            ({
              next: (estimate: any) => {
          this.CartTotalAmount = this.CartTotalAmount + totalAmount

                this.internationalEstimatePrice = estimate
                console.log(estimate)
                this.OrderItem.push({
                  pridReferenceNumber: estimate.pridReferenceNumber,
                  sku: estimate.sku,
                  productType: estimate.productType,
                  retailPrice: estimate.retailPrice,
                  quantity: estimate.quantity,
                  totalRetailPrice: estimate.totalRetailPrice,
                  orderId: estimate.orderId,
                  orderNumber: estimate.orderNumber,
                  discountPercentage: estimate.discountPercentage,
                  retailCost: estimate.retailCost,
                  totalRetailCost: estimate.totalRetailCost,
                  prideComissionPercentage: estimate.prideComissionPercentage,
                  pridProfit: estimate.pridProfit,
                  isProcessed: estimate.isProcessed,
                  isTestRecord: estimate.isTestRecord,
                  country: estimate.country,
                  providerName: estimate.providerName,
                  productDisplayText: estimate.productDisplayText,
                  logoUrl: estimate.logoUrl,
                  phoneNumber: estimate.phoneNumber,
                  productName: estimate.productName,
                  recieverId: estimate.recieverId,
                  unRoundedSendValue:estimate.unRoundedSendValue
                })
                // this.toastr.success('Item added to cart successfully', 'Success')
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.Loader = false
              },
              error: e => {
                if (e.error.message) {
                  this.Loader = false
                  this.toastr.error('Oops!', e.error.message);
                }
                else {
                  this.Loader = false
                  this.toastr.error('Oops!', "Something went wrong");
                }
              }
            })
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
    // setTimeout(() => {
    //   console.log(RecieverId)
    //   this.OrderItem.push({
    //     pridReferenceNumber: pridReferenceNumber,
    //     sku: SKU,
    //     productType: 1,
    //     retailPrice: amount,
    //     quantity: 1,
    //     totalRetailPrice: amount * 1,
    //     orderId: 0,
    //     orderNumber: "",
    //     discountPercentage: 0,
    //     retailCost: 0,
    //     totalRetailCost: 0,
    //     prideComissionPercentage: 0,
    //     pridProfit: 0,
    //     isProcessed: false,
    //     isTestRecord: false,
    //     country: this.CountryIso,
    //     providerName: providerCode,
    //     productDisplayText: displayText,
    //     logoUrl: imageURL,
    //     phoneNumber: countryCode + "" + recieverPhone,
    //     productName: displayText,
    //     recieverId: RecieverId
    //   })
    //   console.log(this.OrderItem)
    // }, 2000)

    // this.Loader = false
    // Swal.fire("Success", "Item added to cart successfully", 'success')
    this.saveObjectToCookie(this.OrderItem)
    this.ResetAddToCart()
  }
  async AddToCartPridProduct(customerFirstName, customerLastName, customerEmail, customerPone,
    recieverFirstName, recieverLastName, recieverEmail, recieverPhone, Quantity) {
    console.log(this.PridProductRecieverId)
    var numb = customerPone.replace(/[^\d]/g, "")
    customerPone = numb

    var recnumb = recieverPhone.replace(/[^\d]/g, "")
    recieverPhone = recnumb
    if (this.PridProductRecieverId == 0 || this.PridProductRecieverId == undefined) {
      this.toastr.error("Please select receiver", 'Cannot Add to Cart')
      return
    }

    this.Loader = true
    if (customerFirstName == "") {
      Swal.fire("Customer FirstName is Required", "", "warning")
      this.Loader = false
      return
    }
    if (customerLastName == "") {
      Swal.fire("Customer LastName is Required", "", "warning")
      this.Loader = false
      return
    }
    if (customerPone == "") {
      Swal.fire("Customer Mobile Number is Required", "", "warning")
      this.Loader = false
      return
    }
    if (recieverFirstName == "") {
      Swal.fire("Reciever FirstName is Required", "", "warning")
      this.Loader = false
      return
    }
    if (recieverLastName == "") {
      Swal.fire("Reciever LastName is Required", "", "warning")
      this.Loader = false
      return
    }
    if (recieverPhone == "") {
      Swal.fire("Reciever Mobile Number is Required", "", "warning")
      this.Loader = false
      return
    }
    this.boolProductSection = true
    if (this.boolCustomerFirstName == true) {
      var User = {
        id: this.Customer_Sender_Id,
        firstName: customerFirstName,
        lastName: customerLastName,
        email: customerEmail,
        mobileNumber: customerPone,
        password: "",
        isVerified: true,
        otpNumber: "",
        deviceId: "",
        isFirstLogin: true,
        roleType: 5,
        isMobileUser: true,
        stripeCustomerId: "",
        isActive: true,
        retailerId: 0,
        isTestAccount: true
      }
      await this.userService.CreatePridUser(User).subscribe((res: any) => {
        console.log(res)
      })
    }
    if (this.boolRecieverFirstName == true) {
      var recieverReq = {
        firstName: recieverFirstName,
        lastName: recieverLastName,
        email: recieverEmail,
        mobileNumber1: recieverPhone,
        mobileNumber2: "",
        address: "",
        customerPhoneNumber: this.CustomerPhoneNo,
        sender_Customer_UserId: 7
        // sender_Customer_UserId: this.Customer_Sender_Id
      }
      await this.userService.CreatePridReciever(recieverReq).subscribe((res: any) => {
        console.log(res)
        this.PridRecieverId = res.id
      })
    }
    console.log(this.activeSelectedProduct)
    this.OrderItem.push({
      pridReferenceNumber: "",
      sku: this.activeSelectedProduct.sku,
      productType: 3,
      retailPrice: this.activeSelectedProduct.retailPrice,
      quantity: Quantity,
      totalRetailPrice: this.activeSelectedProduct.retailPrice * Quantity,
      orderId: 0,
      orderNumber: "",
      discountPercentage: 0,
      retailCost: 0,
      totalRetailCost: 0,
      prideComissionPercentage: 0,
      pridProfit: 0,
      isProcessed: false,
      isTestRecord: false,
      productDisplayText: this.activeSelectedProduct.productName,
      logoUrl: this.imageURL + "" + this.activeSelectedProduct.imageUrl,
      phoneNumber: recieverPhone,
      productId: this.activeSelectedProduct.id,
      productName: this.activeSelectedProduct.productName,
      recieverId: this.PridProductRecieverId,

    })
    // this.toastr.success('Item added to cart successfully', 'Success')
    console.log(this.OrderItem, this.PridProductRecieverId, this.PridRecieverId)
    let quantityAmount = this.activeSelectedProduct.retailPrice * Quantity
    // const totalAmount = parseInt(quantityAmount, 10)

    this.CartTotalAmount = this.CartTotalAmount + quantityAmount
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.Loader = false
    // Swal.fire("Success", "Item added to cart successfully", 'success')
    //this.saveObjectToCookie(this.OrderItem)
    this.ResetAddToCart()
    this.loadRecievers()
  }
  updateReceiverButton = false
  addReceiverButton = false
  recieverSelect(reciever) {
    this.recieverfirstName = "",
    this.recieverlastName = ""
    console.log(reciever)
    this.PridProductRecieverId = parseInt(reciever.value)
    this.Loader = true
    console.log(this.recieverDetails, reciever.value)
    console.log(reciever.value)

    if (reciever.value == 0) {
      this.updateReceiverButton = false
      this.addReceiverButton = true
      //Create new reciever
      this.btnBoolReceiver = false
      this.boolRecieverFirstName = true
      this.boolRecieverLastName = true
      this.boolRecieverMobile = true
      this.PridProductRecieverId = reciever.value
      this.recieverfirstName = "",
        this.recieverlastName = ""
      this.recieverEmail = ""
      this.recieverMobile = ""
      //this.savePridProductReceiverToCookie(this.PridProductRecieverId)
      this.Loader = false
      console.log("Receiver")
      //  return
    }
    else if (reciever.value > 0) {
      this.updateReceiverButton = true
      this.addReceiverButton = false
      //Update fields
      this.btnBoolReceiver = true
      this.boolRecieverFirstName = false
      this.boolRecieverLastName = false
      this.boolRecieverMobile = false
      var selectedReciever = this.recieverDetails.find(rec => rec.id == reciever.value)
      this.recieverfirstName = selectedReciever.firstName
      this.recieverlastName = selectedReciever.lastName
      this.recieverMobile = selectedReciever.mobileNumber1
      this.recieverEmail = selectedReciever.email
      this.ProductRecieverId = reciever.value
      this.PridProductRecieverId = reciever.value
      this.PridRecieverId = reciever.value
      this.savePridProductReceiverToCookie(this.PridProductRecieverId)
      this.Loader = false
      // return
    }
    const selectedReceiver = this.recieverDetails.find(obj => obj.id === this.PridProductRecieverId);
    console.log(selectedReceiver)
    if (reciever.value != 0 && !selectedReceiver.firstName || selectedReceiver.firstName == "" || selectedReceiver.lastName == "" || selectedReceiver.firstName == '' || selectedReceiver.lastName == '') {
      this.updateReceiverButton = true
      this.addReceiverButton = false
      console.log(selectedReceiver, reciever.value)
      this.boolRecieverFirstName = true
      this.Loader = false
      return
    }
    this.Loader = false
  }
  loadRecievers() {
    this.Loader = true
    console.log(this.Customer_Sender_Id)
    this.retailerService.GetRecieversByCustomer(this.Customer_Sender_Id).subscribe
      ({
        next: (res: any) => {
          this.recieverDetails = res
          console.log(this.recieverDetails)
          this.recieversOptions = [{ value: '0', label: 'Create New Receiver' }]
          for (let i = 0; i < this.recieverDetails.length; i++) {
            if (this.recieverDetails[i].firstName != "") {
              this.recieversOptions.push({
                label: this.recieverDetails[i].firstName + " " + this.recieverDetails[i].lastName,
                value: this.recieverDetails[i].id
              })
            }
            else {
              this.recieversOptions.push({
                label: this.recieverDetails[i].mobileNumber1,
                value: this.recieverDetails[i].id
              })
            }
          }
          this.Loader = false
          console.log(this.recieversOptions)
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            // this.toastr.error('Oops!', "Something went wrong");
          }
        },
        complete:()=>{
          // this.hdnPridProductDetails.nativeElement.focus();
        }
      })
    //  this.loadActiveCountries()
  }
  loadActiveCountries() {
    this.Loader = true
    this.pridActiveCountries = []
    this.countryService.GetActiveCountries().subscribe
      ({
        next: (res: any) => {
          this.activeCountries = res
          console.log('Active countries',this.activeCountries)

          const liberiaCountry = this.activeCountries.find(country => country.name === 'Liberia');
          if (liberiaCountry) {
            this.pridActiveCountries.push({ label: liberiaCountry.name, value: liberiaCountry.id });
        }

          for (let i = 0; i < this.activeCountries.length; i++) {
            if (this.activeCountries[i].name === 'Liberia') {
              continue; // Skip Liberia
          }
            this.pridActiveCountries.push({ label: this.activeCountries[i].name, value: this.activeCountries[i].id })
          }
          console.log(this.pridActiveCountries)
          this.changeActiveCountry(this.pridActiveCountries[0])
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  async changeActiveCountry(country) {
    console.log(country.value)
    this.Loader = true
    this.activeSelectedCountry = country.value
    console.log(this.activeSelectedCountry)
    await this.locationService.getActiveLocations().subscribe
      ({
        next: (res: any) => {
          let data = res
          console.log(data)
          this.activeLocations=[]
          const monroviaCity = this.activeCountries.find(country => country.name === 'Monrovia');
          if (monroviaCity) {
            this.activeLocations.push({ label: monroviaCity.locationCity, value: monroviaCity.id });
        }
        for (let i = 0; i < data.length; i++) {
          if (data[i].locationCity === 'Liberia') {
            continue; // Skip Liberia
          }
          this.activeLocations.push({ label: data[i].locationCity, value: data[i].id })
          }
          console.log(this.activeLocations)
          this.changeActiveLocation(this.activeLocations[0])
          //this.savePridProductCountryToCookie(this.activeSelectedCountry)
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  changeActiveLocation(location) {
    this.Loader = true
    console.log(location,this.activeLocations)
    this.activeSelectedLocation = this.activeLocations.find(x => x.value == location.value)
    console.log(this.activeSelectedLocation)
    this.productService.GetActiveProduct().subscribe
      ({
        next: (res: any) => {
          this.activeProducts = res
          console.log(res)
          this.savePridProductLocationToCookie(this.activeSelectedLocation)
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })

  }
  
  changeActiveProduct(id) {
    this.Loader = true
    this.boolDmstcAmountValue = false
    this.dmstcAmountValue = 0
    this.productService.GetProduct(id.value).subscribe
      ({
        next: (res: any) => {
          
          // this.activeSelectedCountry = res.id
          this.activeSelectedProduct = res;
          this.Loader = false;
          this.productDetailPage = true;
            (<HTMLButtonElement>this.btnAddToCartPridProduct.nativeElement).focus();
        },
        error: e => {
          if (e.error.message) {
            this.toastr.error('Oops!', e.error.message);
            this.Loader = false
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
            this.Loader = false
          }
        }
      })

  }
  async PlaceOrder() {
    if (this.OrderItem.length == 0) {
      Swal.fire("Empty", "Your cart is empty right now please add items", "warning")
      return
    }
    this.SubmitOrderButton = false
    console.log(this.activeSelectedLocation.value)
    console.log(this.PridProductRecieverId, this.activeSelectedCountry)
    this.Loader = true
    var order:any;
    if (this.PridProductRecieverId > 0) {
       order = {
        id: 0,
        stripeTransactionId: "",
        totalAmount: this.CartTotalAmount,
        //update when live
        sender_Customer_UserId: this.Customer_Sender_Id,
        orderPlacedBy: 4,
        orderNumber: "",
        // update when live
        senderId: this.Customer_Sender_Id,
        recieverId: this.PridProductRecieverId,
        countryId: this.activeSelectedCountry,
        locationId: parseInt(this.activeSelectedLocation.value),
        deliveryAddress: "",
        orderStatus: 1,
        isPickUp: false,
        isTestRecord: false,
        deliveryMsg:this.txtDeliveryMsg.nativeElement.value,
        orderItems: this.OrderItem
      }
    }
    else {
       order = {
        id: 0,
        stripeTransactionId: "",
        totalAmount: this.CartTotalAmount,
        //update when live
        sender_Customer_UserId: this.Customer_Sender_Id,
        orderPlacedBy: 4,
        orderNumber: "",
        // update when live
        senderId: this.Customer_Sender_Id,
        recieverId: this.PridProductRecieverId,
        countryId: 0,
        locationId: 0,
        deliveryAddress: "",
        orderStatus: 1,
        isPickUp: false,
        isTestRecord: false,
        deliveryMsg:'',
        orderItems: this.OrderItem
      }
    }
    console.log(order)

    //this.CartTotalAmount = 0
    this.retailerService.PlaceOrder(order).subscribe
      ({
        next: (res: any) => {

          console.log(res)
          console.log(res.orderItems.length)
          if (res.orderItems.length == 0) {
            this.SubmitOrderButton = false
            this.CartTotalAmount = 0
          }
          else {
            this.SubmitOrderButton = true
            this.orderNumber = res.orderNumber
          }
          this.OrderItem = res.orderItems
          for (let i = 0; i < res.orderItems.length; i++) {
            if (!res.orderItems[i].isProcessed) {
              this.toastr.info(res.orderItems[i].ErrorMsg, "Failed Item" + res.orderItems[i].productDisplayText)
              // console.log("False")
              // console.log(res.orderItems[i])
              this.CartFailedAmount += parseFloat(res.orderItems[i].totalRetailPrice)
            }
            else {
              this.CartProcessedAmount += parseFloat(res.orderItems[i].totalRetailPrice)
              this.toastr.success('Order item placed successfully', 'Success')
              this.updateBalance();
            }
          }
          // console.log(this.OrderItem)
          //this.OrderItem = res.orderItems
          this.saveObjectToCookie(this.OrderItem)
          this.saveObjectToCookie(res)
          this.saveButtonPlaceOrder()
          this.Loader = false
          // Swal.fire("Success", "Order Placed successfully", "success")

          // this.ResetAll()
        },
        error: e => {
          this.Loader = false
          if (e.error.message) {
            if(e.error.message=="Prepaid") {
            this.toastr.error("Out of Balance. Please recharge your account");
            this.router.navigateByUrl('/payments');
            return;
            }
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  updateBalance(): void {
    this.retailerSideBarService.triggerBalanceRefresh();
  }
  removeCartItem(index) {
    if (this.OrderItem.length == 0) {
      this.SubmitOrderButton = false
      this.resetCart()
    }
    if (index !== -1) {
      this.CartTotalAmount = this.CartTotalAmount - this.OrderItem[index].totalRetailPrice
      this.OrderItem.splice(index, 1);
      this.saveObjectToCookie(this.OrderItem)
    }
  }
  ReOrder(cart) {
    this.Loader = true
    this.ReProcessOrderItem = []
    this.ReProcessOrderItem.push(cart)
    this.retailerService.ReProcessOrderItems(this.ReProcessOrderItem).subscribe
      ({
        next: (res: any) => {
          // console.log(res)
          this.Loader = false
          this.updateBalance();
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  onItemClick(item, accountNumber) {
    this.selectedItem = null;
    if (this.selectedItem === item) {
      this.selectedItem = null; // If the same item is clicked, toggle it off
    } else {
      this.selectedItem = item; // Otherwise, set the clicked item as selected
    }
    this.GetDomesticProducts(item.value, accountNumber)
  }

  onItemClickInternational(item, accountNumber) {
    
    this.boolShowAmountInternational=true
    this.selectedItemInternational = null;
    if (this.selectedItemInternational === item) {
      this.selectedItemInternational = null;
    } else {
      this.selectedItemInternational = item;
    }
    console.log(item.value,accountNumber)
    this.GetProductsbyCards(item.value, accountNumber)
  }

  onItemProductClick(item) {
    console.log(item)
    this.selectedItemProduct = null
    if (this.selectedItemProduct === item) {
      this.selectedItemProduct = null;
    } else {
      this.selectedItemProduct = item;
      this.changeIntlProduct(item)
    }
    this.boolShowAmount = true
  }

  onItemProductClickInternational(item) {
    this.selectedItemProductInternational = null
    if (this.selectedItemProductInternational === item) {
      this.selectedItemProductInternational = null;
    } else {
      this.selectedItemProductInternational = item;
      this.changeIntlProduct(item)
    }
    this.boolShowAmountInternational = true
  }

  changeProvider() {
    this.boolDmstcAmountValue = false
    this.dmstcAmountValue = 0

    this.boolShowAmount = false
    this.selectedItem = null
    this.selectedItemProduct = null
    // this.boolShowProvider = false
    this.GetDomesticProviders()
  }

  changeProviderInternational(accountNumber) {
    this.boolDmstcAmountValue = false
    this.dmstcAmountValue = 0
    this.boolAmountRange=false
    this.boolShowAmountInternational = false
    this.selectedItemInternational = null
    this.selectedItemProductInternational = null
    this.intlAmountValue=null
    // this.boolShowProviderInternational=false
    // this.boolShowProvider = false
     this.GetProvidersProductsByNumber(accountNumber)
  }

  addClassToBody() {
    this.renderer.addClass(document.body, 'sidebar-collapse');
  }
  removeClassFromBody() {
    this.renderer.removeClass(document.body, 'sidebar-collapse');
  }

  GetTopUpTransactionsByCustomerId() {
    this.retailerService.GetTopUpTransactionsByCustomerId(this.Customer_Sender_Id).subscribe
      ({
        next: (res: any) => {
          console.log(res)
          this.TopupList = res
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  backSelectProduct() {
    this.boolDmstcAmountValue = false
    this.dmstcAmountValue = 0
    this.selectedItemProduct = null;
    // this.boolShowAmount=false
  }
  selectedCountryIso: string
  regionCode: string
  onCountryChange(event: any) {
    this.selectedCountry = ""
    console.log(event.source.value)
    var countryData = this.countries.find(m => m.code == event.source.value)
    this.selectedCountryIso = countryData.code
    this.regionCode = countryData.iso

    console.log(countryData)
    this.selectedCountry = countryData.flag
    this.GetSingleCountry(event.source.value)
  }
  ClearOrder() {
    this.SubmitOrderButton = false
    this.OrderItem = []
    this.CartTotalAmount = 0
    window.location.reload();
  }
  filterCountry: any
  filterCountries() {
    console.log(this.filterCountry)
    var filter
    filter = this.countries.filter(country => country.code == this.filterCountry)

    if (this.filterCountry == "" || this.filterCountry == null) {
      this.GetCountries()
    }
    if (filter == "") {
      return
    }
    this.countries = filter
    console.log(filter)
  }
  //Save to cookie
  saveObjectToCookie(object) {
    this.cookieService.set('orderCookie', JSON.stringify(object));
  }
  saveButtonPlaceOrder() {
    this.cookieService.set('orderButtonCookie', JSON.stringify("true"));
  }
  saveCustomerObjectToCookie(object) {
    this.cookieService.set('customerObject', JSON.stringify(object));
  }
  savePridProductReceiverToCookie(object) {
    this.cookieService.set('pridProductReceiver', JSON.stringify(object));
  }
  savePridProductCountryToCookie(object) {
    this.cookieService.set('pridProductCountry', JSON.stringify(object));
  }
  savePridProductLocationToCookie(object) {
    this.cookieService.set('pridProductLocation', JSON.stringify(object));
  }
  //Retrieve
  getOrderButtonCookie() {
    const buttonPlaceOrder = this.cookieService.get('orderButtonCookie');
    var boolValue = (/true/i).test(buttonPlaceOrder)
    console.log(buttonPlaceOrder, boolValue)
    this.SubmitOrderButton = boolValue
  }
  getObjectFromCookie() {
    const myObjectString = this.cookieService.get('orderCookie');
    console.log(myObjectString)
    if (myObjectString) {
      const myObject = JSON.parse(myObjectString);
      console.log(myObject)
      if (!myObject.orderItems) {
        this.OrderItem = myObject
        for (let i = 0; i < myObject.length; i++) {
          this.CartTotalAmount += myObject[i].totalRetailPrice
        }
      }
      else {
        this.OrderItem = myObject.orderItems
        this.orderNumber = myObject.orderNumber
        console.log(this.OrderItem)
        for (let i = 0; i < this.OrderItem.length; i++) {
          this.CartTotalAmount += this.OrderItem[i].totalRetailPrice
        }
      }

      console.log(myObject);
    } else {
      console.log('Object not found in cookie.');
    }
  }
  async getCustomerObjectFromCookie() {
    const myObjectString = this.cookieService.get('customerObject');
    if (myObjectString) {
      const myObject = JSON.parse(myObjectString);
      this.PridCustomerMobileNumber1 = myObject.mobileNumber
      await this.CreateRetailerFromCookie(this.PridCustomerMobileNumber1)
    } else {
      console.log('Object not found in cookie.');
    }
  }
  async getReceiverObjectFromCookie() {
    const myObjectString = this.cookieService.get('pridProductReceiver');
    if (myObjectString) {
      const myObject = JSON.parse(myObjectString);
      this.PridProductRecieverId = myObject
      let selectedReceiver
      this.retailerService.GetRecieversByCustomer(this.Customer_Sender_Id).subscribe
        ({
          next: (res: any) => {
            this.recieverDetails = res
            console.log(this.recieverDetails)
            this.recieversOptions = []
            this.Loader = false
            for (let j = 0; j < this.recieverDetails.length; j++) {
              if (this.recieverDetails[j].id == this.PridProductRecieverId) {
                this.recieverfirstName=this.recieverDetails[j].firstName
                this.recieverlastName=this.recieverDetails[j].lastName
                this.recieverMobile=this.recieverDetails[j].mobileNumber1
              }
            }

            // const selectedReceiver = this.recieversOptions.filter(obj => obj.value === this.PridProductRecieverId);
            // console.log(selectedReceiver)
            // if (selectedReceiver) {
            //   console.log(selectedReceiver)
            //   this.recieversOptions = selectedReceiver
            // }
          },
          error: e => {
            if (e.error.message) {
              this.Loader = false
              this.toastr.error('Oops!', e.error.message);
            }
            else {
              this.Loader = false
              this.toastr.error('Oops!', "Something went wrong");
            }
          }
        })


    }
  }
  getCountryObjectFromCookie() {
    const myObjectString = this.cookieService.get('pridProductCountry');
    if (myObjectString) {
      const myObject = JSON.parse(myObjectString);
      this.activeSelectedCountry = parseInt(myObject)
      console.log(this.activeSelectedCountry)
    } else {
      console.log('Object not found in cookie.');
    }
  }
  getCustomerLocationFromCookie() {
    const myObjectString = this.cookieService.get('pridProductLocation');
    if (myObjectString) {
      const myObject = JSON.parse(myObjectString);
      this.activeSelectedLocation = {
        id: 0
      }
      console.log(myObject.id, this.activeSelectedLocation.id)
      this.activeSelectedLocation.id = parseInt(myObject.id)
      console.log(this.activeSelectedLocation.id)
    } else {
      console.log('Object not found in cookie.');
    }
  }
  clearCookie() {
    this.cookieService.delete('orderCookie');
    this.cookieService.delete('customerObject');
    this.cookieService.delete('orderButtonCookie')
    this.CartTotalAmount = 0;
    window.location.reload()
  }
  ResetAll() {
    this.btnBoolCustomer = false
    this.btnBoolReceiver = false
    this.boolProductSection = false
    this.internationalAmountValue.nativeElement.value = '';
    this.Products = []
    this.intlproductsOption = []
    this.intlSelectedProduct = null
    this.intlSelectedProvider = null
    this.intlProductRefenceNumber = ""
    this.OrderItem = []
    this.ReProcessOrderItem = []
    this.CustomerPhoneNo = "";
    this.Customer_Sender_Id = null;
    this.dmstcProductOptions = []
    this.dmstcProviderOptions = []
    this.dmstcProductRefenceNumber = ""
    this.internationalEstimatePrice = ""
    this.domesticEstimatePrice = ""
    this.CustomerDetails = ""
    this.recieverDetails = ""
    this.recieverfirstName = ""
    this.recieverlastName = ""
    this.recieverEmail = ""
    this.recieverMobile = ""
    this.activeCountries = []
    this.activeLocations = []
    this.activeProducts = []
    this.activeSelectedCountry = null
    this.activeSelectedLocation = []
    this.activeSelectedProduct = []
    this.boolCustomerFirstName = false
    this.boolCustomerLastName = false
    this.boolCustomerMobile = false
    this.boolRecieverFirstName = false
    this.boolRecieverLastName = false
    this.boolRecieverMobile = false
    this.PridCustomerFirstName = ""
    this.PridCustomerLastName = ""
    this.PridCustomerMobileNumber1 = ""
    this.PridCustomerEmail = ""
    this.boolPridCustomerFirstName = true
    this.boolPridCustomerLastName = true
    this.ProductMinPrice = ""
    this.ProductMaxPrice = ""
    this.boolAmountRange = false;
    this.CartTotalAmount = 0
    this.PridRecieverId = null
    this.selectedItem = null;
    this.selectedItemProduct = null;
    this.boolShowAmount = false
    this.boolShowProvider = false
    this.domesticPhoneError = ""
    this.pridActiveCountries = []
    this.CountryValue = "Select Country"
    this.selectedCountry = "";
    this.phNumber = "";
    this.countries = [];
    this.SubmitOrderButton = false
    this.ProductRecieverId = null
    this.countryControl = new FormControl();
    this.TopupList = []
    this.intlAmountValue = 0
    this.dmstcAmountValue = 0
    this.boolIntlAmountValue = false
    this.boolDmstcAmountValue = false
    this.recieversOptions = []
    this.countryOptions = []
    this.cityOptions = []
    this.productOptions = []
    this.selectedCountryCode = "+1"; // Default country code
    this.phoneNumber = "";
    this.TopUpsByCustomerId = null
    this.country = []
    this.intlcountryList = []
    this.CountryIso = ""
    this.CountryName = ""
    this.ProviderCode = ""
    this.ProviderName = ""
    this.logoUrl = ""
    this.providers = {}
    this.intlprovidersOption = []
    this.productRequest = {
      countryIso: "",
      providerCode: "",
      receiveCountryName: "",
      providerName: "",
      accountNumber: "",
      logoUrl: "",
      logRequest: true
    }
    this.firstName.nativeElement.value = '';
    this.lastName.nativeElement.value = '';
    this.cookieService.delete('orderCookie');
    this.cookieService.delete('customerObject');
    this.CartTotalAmount = 0;
    this.PridProductRecieverId = 0
    this.selectedItemInternational=null
    this.selectedItemProductInternational=null
    this.boolShowAmountInternational=false
    this.boolShowProviderInternational=false
    this.GetCountries()
  }
  ResetAllCart(mobilenumber) {
    localStorage.setItem('CustomerMobile',mobilenumber)
    this.btnBoolCustomer = false
    this.btnBoolReceiver = false
    this.boolProductSection = false
    this.internationalAmountValue.nativeElement.value = '';
    this.Products = []
    this.intlproductsOption = []
    this.intlSelectedProduct = null
    this.intlSelectedProvider = null
    this.intlProductRefenceNumber = ""
    this.OrderItem = []
    this.ReProcessOrderItem = []
    this.CustomerPhoneNo = "";
    this.Customer_Sender_Id = null;
    this.dmstcProductOptions = []
    this.dmstcProviderOptions = []
    this.dmstcProductRefenceNumber = ""
    this.internationalEstimatePrice = ""
    this.domesticEstimatePrice = ""
    this.CustomerDetails = ""
    this.recieverDetails = ""
    this.recieverfirstName = ""
    this.recieverlastName = ""
    this.recieverEmail = ""
    this.recieverMobile = ""
    this.activeCountries = []
    this.activeLocations = []
    this.activeProducts = []
    this.activeSelectedCountry = null
    this.activeSelectedLocation = []
    this.activeSelectedProduct = []
    this.boolCustomerFirstName = false
    this.boolCustomerLastName = false
    this.boolCustomerMobile = false
    this.boolRecieverFirstName = false
    this.boolRecieverLastName = false
    this.boolRecieverMobile = false
    this.PridCustomerFirstName = ""
    this.PridCustomerLastName = ""
    this.PridCustomerEmail = ""
    this.boolPridCustomerFirstName = true
    this.boolPridCustomerLastName = true
    this.ProductMinPrice = ""
    this.ProductMaxPrice = ""
    this.boolAmountRange = false;
    this.CartTotalAmount = 0
    this.PridRecieverId = null
    this.selectedItem = null;
    this.selectedItemProduct = null;
    this.boolShowAmount = false
    this.boolShowProvider = false
    this.domesticPhoneError = ""
    this.pridActiveCountries = []
    this.CountryValue = "Select Country"
    this.selectedCountry = "";
    this.phNumber = "";
    this.countries = [];
    this.SubmitOrderButton = false
    this.ProductRecieverId = null
    this.countryControl = new FormControl();
    this.TopupList = []
    this.intlAmountValue = 0
    this.dmstcAmountValue = 0
    this.boolIntlAmountValue = false
    this.boolDmstcAmountValue = false
    this.recieversOptions = []
    this.countryOptions = []
    this.cityOptions = []
    this.productOptions = []
    this.selectedCountryCode = "+1"; // Default country code
    this.phoneNumber = "";
    this.TopUpsByCustomerId = null
    this.country = []
    this.intlcountryList = []
    this.CountryIso = ""
    this.CountryName = ""
    this.ProviderCode = ""
    this.ProviderName = ""
    this.logoUrl = ""
    this.providers = {}
    this.intlprovidersOption = []
    this.productRequest = {
      countryIso: "",
      providerCode: "",
      receiveCountryName: "",
      providerName: "",
      accountNumber: "",
      logoUrl: "",
      logRequest: true
    }
    this.firstName.nativeElement.value = '';
    this.lastName.nativeElement.value = '';
    this.cookieService.delete('orderCookie');
    this.cookieService.delete('customerObject');
    this.CartTotalAmount = 0;
    this.CartFailedAmount=0;
    this.CartProcessedAmount=0
    this.PridProductRecieverId = 0
    this.selectedItemInternational=null
    this.selectedItemProductInternational=null
    this.boolShowAmountInternational=false
    this.boolShowProviderInternational=false
    this.CreateRetailer(mobilenumber)
    this.GetCountries()
  }
  ResetAddToCart() {
    this.productDetailPage = false
    this.firstName.nativeElement.value = '';
    this.lastName.nativeElement.value = '';
    this.internationalAmountValue.nativeElement.value = '';
    this.Products = []
    this.intlproductsOption = []
    this.intlSelectedProduct = null
    this.intlSelectedProvider = null
    this.intlProductRefenceNumber = ""
    // this.OrderItem = []
    this.ReProcessOrderItem = []
    this.dmstcProductOptions = []
    this.dmstcProviderOptions = []
    this.dmstcProductRefenceNumber = ""
    this.internationalEstimatePrice = ""
    this.domesticEstimatePrice = ""
    // this.recieverDetails = ""
    //this.recieverfirstName = ""
    // this.recieverlastName = ""
    // this.recieverEmail = ""
    // this.recieverMobile = ""
    // this.activeCountries = []
    // this.activeLocations = []
    //this.activeProducts = []
    //this.activeSelectedCountry = null
    // this.activeSelectedLocation = []
    this.activeSelectedProduct = []
    // this.boolCustomerFirstName = false
    // this.boolCustomerLastName = false
    // this.boolCustomerMobile = false

    this.boolRecieverFirstName = false
    this.boolRecieverLastName = false
    this.boolRecieverMobile = false

    // this.PridCustomerFirstName = ""
    // this.PridCustomerLastName = ""
    // this.PridCustomerMobileNumber1 = ""
    // this.PridCustomerEmail = ""
    // this.boolPridCustomerFirstName = true
    // this.boolPridCustomerLastName = true
    this.ProductMinPrice = ""
    this.ProductMaxPrice = ""
    this.boolAmountRange = false;
    // this.CartTotalAmount = 0
    this.PridRecieverId = null
    this.selectedItem = null;
    this.selectedItemProduct = null;
    this.boolShowAmount = false
    this.boolShowProvider = false
    this.domesticPhoneError = ""
    // this.pridActiveCountries = []
    // this.CountryValue = "Select Country"
    // this.selectedCountry = "";
    this.phNumber = "";
    this.countries = [];
    this.SubmitOrderButton = false
    this.ProductRecieverId = null
    this.countryControl = new FormControl();
    // this.TopupList = []
    this.intlAmountValue = 0
    this.dmstcAmountValue = 0
    this.boolIntlAmountValue = false
    this.boolDmstcAmountValue = false
    // this.recieversOptions = []
    this.countryOptions = []
    this.cityOptions = []
    this.productOptions = []
    this.selectedCountryCode = "+1"; // Default country code
    this.phoneNumber = "";
    this.TopUpsByCustomerId = null
    this.country = []
    this.intlcountryList = []
    this.CountryIso = ""
    this.CountryName = ""
    this.ProviderCode = ""
    this.ProviderName = ""
    this.logoUrl = ""
    this.providers = {}
    this.intlprovidersOption = []
    this.productRequest = {
      countryIso: "",
      providerCode: "",
      receiveCountryName: "",
      providerName: "",
      accountNumber: "",
      logoUrl: "",
      logRequest: true
    }
    // this.GetCountries()
    this.selectedItemInternational=null
    this.selectedItemProductInternational=null
    this.boolShowAmountInternational=false
    this.boolShowProviderInternational=false
  }
  ResetAddToCartInternational() {
    this.firstName.nativeElement.value = '';
    this.lastName.nativeElement.value = '';
    this.internationalAmountValue.nativeElement.value = '';
    this.Products = []
    this.intlproductsOption = []
    this.intlSelectedProduct = null
    this.intlSelectedProvider = null
    this.intlProductRefenceNumber = ""
    // this.OrderItem = []
    this.ReProcessOrderItem = []
    this.dmstcProductOptions = []
    this.dmstcProviderOptions = []
    this.dmstcProductRefenceNumber = ""
    this.internationalEstimatePrice = ""
    this.domesticEstimatePrice = ""
    this.recieverDetails = ""
    this.recieverfirstName = ""
    this.recieverlastName = ""
    this.recieverEmail = ""
    this.recieverMobile = ""
    this.activeCountries = []
    this.activeLocations = []
    this.activeProducts = []
    this.activeSelectedCountry = null
    this.activeSelectedLocation = []
    this.activeSelectedProduct = []
    // this.boolCustomerFirstName = false
    // this.boolCustomerLastName = false
    // this.boolCustomerMobile = false
    this.boolRecieverFirstName = false
    this.boolRecieverLastName = false
    this.boolRecieverMobile = false
    // this.PridCustomerFirstName = ""
    // this.PridCustomerLastName = ""
    // this.PridCustomerMobileNumber1 = ""
    // this.PridCustomerEmail = ""
    // this.boolPridCustomerFirstName = true
    // this.boolPridCustomerLastName = true
    this.ProductMinPrice = ""
    this.ProductMaxPrice = ""
    this.boolAmountRange = false;
    // this.CartTotalAmount = 0
    this.PridRecieverId = null
    this.selectedItem = null;
    this.selectedItemProduct = null;
    this.boolShowAmount = false
    this.boolShowProvider = false
    this.domesticPhoneError = ""
    // this.pridActiveCountries = []
    this.CountryValue = "Select Country"
    this.selectedCountry = "";
    this.phNumber = "";
    this.countries = [];
    this.SubmitOrderButton = false
    this.ProductRecieverId = null
    this.countryControl = new FormControl();
    // this.TopupList = []
    this.intlAmountValue = 0
    this.intlunRoundedSendValue=0;
    this.dmstcAmountValue = 0
    this.boolIntlAmountValue = false
    this.boolDmstcAmountValue = false
    this.recieversOptions = []
    this.countryOptions = []
    this.cityOptions = []
    this.productOptions = []
    this.selectedCountryCode = "+1"; // Default country code
    this.phoneNumber = "";
    this.TopUpsByCustomerId = null
    this.country = []
    // this.intlcountryList = []
    this.CountryIso = ""
    this.CountryName = ""
    this.ProviderCode = ""
    this.ProviderName = ""
    this.logoUrl = ""
    this.providers = {}
    this.intlprovidersOption = []
    this.productRequest = {
      countryIso: "",
      providerCode: "",
      receiveCountryName: "",
      providerName: "",
      accountNumber: "",
      logoUrl: "",
      logRequest: true
    }
    this.CartProcessedAmount=0
    this.selectedItemInternational=null
    this.selectedItemProductInternational=null
    this.boolShowAmountInternational=false
    this.boolShowProviderInternational=false
    this.filterCountry=null
  }
  async domesticNumberProcess(phone) {
    await this.GetCountries()
    var numb = phone.replace(/[^\d]/g, "")
    phone = numb
    this.Loader = false
    this.domesticPhoneError = ""
    this.boolShowProvider = true


    console.log(this.intlcountryList)
    await this.GetDomesticProviders();
    // }
  }
  async countryFlagFilter(number, event) {
    console.log('event here',event);
    console.log(event.target.value, number)
    var numb = number.replace(/[^\d]/g, "")
    console.log(numb)
    number = numb
    console.log(number)
    const twoDigits = number.substring(0, 2)
    const threeDigits = number.substring(0, 3)
    const fourDigits = number.substring(0, 4)
    var filter
    var filterFour
    var filterTwo
    var filterThree
    filterTwo = this.flagCountries.filter(country => country.code == twoDigits)
    filterThree = this.flagCountries.filter(country => country.code == threeDigits)
    filterFour = this.flagCountries.filter(country => country.code == fourDigits)
    if (filterTwo.length > 0) {
      this.countryFlagImg = filterTwo[0].flag
      this.internationalCountryCode = filterTwo[0].iso
      this.regionCode = filterTwo[0].iso
      await this.GetSingleCountry(filterTwo[0].code)
    }
    if (filterThree.length > 0) {
      this.countryFlagImg = filterThree[0].flag
      this.internationalCountryCode = filterThree[0].iso
      this.regionCode = filterThree[0].iso
      await this.GetSingleCountry(filterThree[0].code)
    }
    if (filterFour.length > 0) {
      this.countryFlagImg = filterFour[0].flag
      this.internationalCountryCode = filterFour[0].iso
      this.regionCode = filterFour[0].iso
      await this.GetSingleCountry(filterFour[0].code)
    }
  }
  GetProvidersProductsByNumber(phoneNumber) {
    this.intlAmountValue=null
    this.boolIntlAmountValue=false
    console.log(phoneNumber)
    var numb = phoneNumber.replace(/[^\d]/g, "")
    phoneNumber = numb
    console.log(numb, phoneNumber)
    this.Loader = true
    this.intlprovidersOption = []
    this.customService.GetProvidersByPhoneNumber(phoneNumber, this.internationalCountryCode).subscribe
      ({
        next: (res: any) => {
          console.log(res)
          this.providers = res
          this.intlprovidersOption = []
          for (let i = 0; i < this.providers.length; i++) {
            console.log(res[i].providerCode)
            var value = res[i].providerCode
            this.intlprovidersOption.push({ value: value, label: this.providers[i].name, label2: this.providers[i].logoUrl })
          }
          console.log(this.intlprovidersOption)
          if (this.intlprovidersOption.length == 0) {
            this.toastr.error('Please check your mobile number again', "Invalid Phone Number");
            // Swal.fire('Invalid Phone Number', 'Please check your mobile number again', 'error');
          }
          //this.GetProductsByProviders(this.intlprovidersOption[0].value, phoneNumber)
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  async validatePhoneNumber(phoneNumber: string) {
    var numb = phoneNumber.replace(/[^\d]/g, "")
    phoneNumber = numb
    this.Loader = true
    console.log(this.numberLoader)

    this.intlprovidersOption = []
    this.customService.GetProvidersByPhoneNumber(phoneNumber, this.internationalCountryCode).subscribe
      ({
        next: (res: any) => {

          this.providers = res
          this.intlprovidersOption = []
          for (let i = 0; i < this.providers.length; i++) {
            console.log(res[i].providerCode)
            var value = res[i].providerCode
            this.intlprovidersOption.push({ value: value, label: this.providers[i].name, label2: this.providers[i].logoUrl })
          }
          console.log(this.intlprovidersOption)
          this.GetProductsByProviders(this.intlprovidersOption[0].value, phoneNumber)
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
    this.Loader = false
    console.log(this.numberLoader)
  }
  OrderByRefNum(refNum, amount) {
    console.log(refNum, amount)
    this.Loader = true
    this.retailerService.CreateNewTopUpItemByRefNum(refNum, amount).subscribe
      ({
        next: (res: any) => {

          console.log(res)
          this.OrderItem.push({
            pridReferenceNumber: res.pridReferenceNumber,
            sku: res.sku,
            productType: res.productType,
            retailPrice: res.retailPrice,
            quantity: res.quantity,
            totalRetailPrice: res.totalRetailPrice,
            orderId: 0,
            orderNumber: "",
            discountPercentage: 0,
            retailCost: 0,
            totalRetailCost: 0,
            prideComissionPercentage: 0,
            pridProfit: 0,
            isProcessed: false,
            isTestRecord: false,
            country: res.country,
            providerName: res.providerName,
            productDisplayText: res.productDisplayText,
            logoUrl: res.logoUrl,
            phoneNumber: res.phoneNumber,
            productName: "",
            recieverId: res.recieverId,
            UnRoundedSendValue:res.unRoundedSendValue
          })
          this.CartTotalAmount = this.CartTotalAmount + parseInt(res.retailPrice)
          // this.toastr.success('Item added to cart successfully', 'Success')
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })

  }
  PrintRecipt() {
    const url = this.router.serializeUrl(
      // this.router.createUrlTree([`/Pridapp/printrecipt/id${this.orderNumber}`])
      this.router.createUrlTree([environment.appNameUrl+`printrecipt/print/id${this.orderNumber}`])
    )
    console.log(url)
    window.open(url, '_blank')
  }
  DeleteOrderHistory(id) {
    console.log(id)
    this.Loader = true
    this.retailerService.DeleteFromHistory(id).subscribe
      ({
        next: (res: any) => {
          this.GetTopUpTransactionsByCustomerId()
          this.Loader = false
        },
        error: e => {
          console.log(e)
          this.Loader = false
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  resetCart() {
    this.OrderItem = []
    this.boolProductSection = false
    this.PridRecieverId = 0
    this.ProductRecieverId = 0
    this.productDetailPage = false
    this.loadActiveCountries()
    this.loadRecievers()
    this.Loader = false
  }
  async AddReceiver(recieverFirstName, recieverLastName, recieverEmail, recieverPhone) {
    if (recieverFirstName == "") {
      this.toastr.info("Please enter First Name", "Required")
    }
    if (recieverLastName == "") {
      this.toastr.info("Please enter Last Name", "Required")
    }
    if (recieverPhone == "") {
      this.toastr.info("Please enter Phone Number", "Required")
    }
    var numb = recieverPhone.replace(/[^\d]/g, "")
    recieverPhone = numb
    console.log(recieverPhone)
    this.Loader = true
    let recieverRequest = {
      firstName: recieverFirstName,
      lastName: recieverLastName,
      mobileNumber1: recieverPhone,
      mobileNumber2: recieverEmail,
      email: "",
      address: "",
      customerPhoneNumber: this.CustomerPhoneNo,
      sender_Customer_UserId: this.Customer_Sender_Id,
      recieverType:ReceiverType.PridProduct
    }
    console.log(recieverRequest)
    await this.retailerService.CreateReciever(recieverRequest).subscribe
      ({
        next: async (res: any) => {
          console.log(res)
          console.log(recieverFirstName,recieverLastName)
          this.recieversOptions=[]
          this.recieversOptions.push({
            value: res.id, // or whatever unique identifier you have
            label: `${recieverFirstName} ${recieverLastName}`, // Adjust as necessary
        });

       await this.retailerService.GetRecieversByCustomer(this.Customer_Sender_Id).subscribe
      ({
        next: (res: any) => {
          this.recieverDetails = res
          console.log(this.recieverDetails)
          for (let i = 0; i < this.recieverDetails.length; i++) {
            if (this.recieverDetails[i].firstName != "") {
              this.recieversOptions.push({
                label: this.recieverDetails[i].firstName + " " + this.recieverDetails[i].lastName,
                value: this.recieverDetails[i].id
              })
            }
            else {
              this.recieversOptions.push({
                label: this.recieverDetails[i].mobileNumber1,
                value: this.recieverDetails[i].id
              })
            }
          }
          this.recieversOptions.push({ value: '0', label: 'Create New Receiver' })
          this.Loader = false
          console.log(this.recieversOptions)
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
          this.PridProductRecieverId = res.id
          this.boolRecieverFirstName = false
          this.boolRecieverMobile = false
          this.addReceiverButton=false
          // this.boolProductSection=true
          this.savePridProductReceiverToCookie(this.PridProductRecieverId)
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
            this.Loader = false
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
            this.Loader = false
          }
          this.Loader = false
        }
      })
  }

  async UpdateReceiver(recieverFirstName, recieverLastName, recieverEmail, recieverPhone) {
    if (recieverFirstName == "") {
      this.toastr.info("Please enter First Name", "Required")
    }
    if (recieverLastName == "") {
      this.toastr.info("Please enter Last Name", "Required")
    }
    if (recieverPhone == "") {
      this.toastr.info("Please enter Phone Number", "Required")
    }
    var numb = recieverPhone.replace(/[^\d]/g, "")
    recieverPhone = numb
    console.log(recieverPhone)
    this.Loader = true
    let recieverRequest = {
      id: this.PridProductRecieverId,
      firstName: recieverFirstName,
      lastName: recieverLastName,
      mobileNumber1: recieverPhone,
      mobileNumber2: recieverEmail,
      email: "",
      address: "",
      customerPhoneNumber: this.CustomerPhoneNo,
      sender_Customer_UserId: this.Customer_Sender_Id,
      recieverType:ReceiverType.PridProduct
    }
    console.log(recieverRequest)
    await this.retailerService.UpdateReciever(recieverRequest).subscribe
      ({
        next: (res: any) => {
          console.log(res)
          this.PridProductRecieverId = res.id
          this.boolRecieverFirstName = false
          this.boolRecieverMobile = false
          this.savePridProductReceiverToCookie(this.PridProductRecieverId)
          this.Loader = false
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
            this.Loader = false
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
            this.Loader = false
          }
          this.Loader = false
        }
      })
  }

  async UpdateCustomer(customerFirstName, customerLastName, Email, Phone) {
    this.Loader = true
    var numb = Phone.replace(/[^\d]/g, "")
    Phone = numb
    await this.userService.GetUserById(this.Customer_Sender_Id).subscribe
      ({
        next: (res: any) => {
          res.firstName = customerFirstName
          res.lastName = customerLastName
          res.email = Email
          res.deviceId = "1"
          res.otpNumber = "123456"
          res.stripeCustomerId = res.stripeCustomerId.toString(),
          res.password=""
          console.log(res)

          this.userService.UpdateUser(res).subscribe
            ({
              next: (res1: any) => {
                console.log(res1)
                this.btnBoolCustomer = true
                this.boolPridCustomerFirstName = true
                this.boolPridCustomerLastName = true
                this.Loader = false
              },
              error: e => {
                if (e.error.message) {
                  this.Loader = false
                  this.toastr.error('Oops!', e.error.message);
                }
                else {
                  this.Loader = false
                  this.toastr.error('Oops!', "Something went wrong");
                }
              }
            })
        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  // logout() {
  //   this.loginService.logout();
  // }
}

